import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { colorsSemantic } from "../../theme/tokens/colors-semantic.js";
import { TASK_TABS } from "../../hooks/useDashboardTaskFilters.js";

/**
 * The board's four filter pills with their counts.
 *
 * The "Überfällig" pill takes on a warning tint — but only while its count is
 * above zero, so an empty board does not look alarming.
 */
export default function TaskFilterTabs({ counts = {}, active, onSelect }) {
  const { attention } = colorsSemantic;

  return (
    <Box
      sx={{
        display: "flex",
        gap: "7px",
        flexWrap: "wrap",
        padding: "13px 18px",
        borderBottom: `1px solid ${colorsSemantic.border.hairline}`,
      }}
    >
      {TASK_TABS.map((tab) => {
        const count = counts[tab.key] ?? 0;
        const isActive = active === tab.key;
        const warn = tab.key === "ueberfaellig" && count > 0;
        const accent = warn ? attention.overdue : colorsSemantic.text.accent.blue;

        return (
          <Box
            key={tab.key}
            component="button"
            type="button"
            onClick={() => onSelect(tab.key)}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "7px",
              padding: "7px 12px",
              borderRadius: "20px",
              fontSize: "12.5px",
              fontWeight: 600,
              fontFamily: "inherit",
              cursor: "pointer",
              border: `1.5px solid ${isActive ? accent : warn ? attention.warn.border : colorsSemantic.border.card}`,
              backgroundColor: isActive
                ? accent
                : warn
                  ? attention.warn.bg
                  : colorsSemantic.background.paper,
              color: isActive
                ? colorsSemantic.text.inverse
                : warn
                  ? attention.warn.fg
                  : colorsSemantic.text.muted,
            }}
          >
            {tab.label}
            <Box
              component="span"
              sx={{
                fontSize: "11px",
                fontWeight: 700,
                borderRadius: "20px",
                padding: "1px 7px",
                backgroundColor: isActive
                  ? "rgba(255,255,255,.24)"
                  : warn
                    ? colorsSemantic.background.paper
                    : colorsSemantic.surface.table.headerBg,
                color: isActive
                  ? colorsSemantic.text.inverse
                  : warn
                    ? attention.warn.fg
                    : colorsSemantic.text.muted,
              }}
            >
              {count}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

TaskFilterTabs.propTypes = {
  counts: PropTypes.objectOf(PropTypes.number),
  active: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};
